export default "__VITE_ASSET__93670d69__"